import {Table} from "semantic-ui-react";
import {Link} from "react-router-dom";
import React from "react";

export function ContactListItems(props) {
    const contacts = props.contacts;

    const listItems = contacts.map((contact) =>
        <Table.Row key={contact.id}>
            <Table.Cell><Link to={`/contacts/${contact.id}`}>{contact.id}</Link></Table.Cell>
            <Table.Cell>{contact.contact_name}</Table.Cell>
            <Table.Cell>{contact.status}</Table.Cell>
            <Table.Cell>{contact.steuerberater_kontonummer}</Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell> Stb Kto Nr</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{listItems}</Table.Body>
        </Table>
    )
}